/* ==========================================================================
   WISAMIN — PULSE behaviour
   Vanilla JS, no dependencies. Every feature degrades gracefully if its
   section is not present on the page.
   ========================================================================== */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var fmtInt = function (n) { return Number(n).toLocaleString('en-US'); };

  /* ---------- money ------------------------------------------------------ */
  var MONEY_FMT = (window.WISAMIN && window.WISAMIN.moneyFormat) || '฿{{amount}}';
  function money(cents) {
    var v = (cents / 100);
    var s = v.toLocaleString('en-US', { minimumFractionDigits: v % 1 ? 2 : 0, maximumFractionDigits: 2 });
    return MONEY_FMT.replace(/\{\{\s*amount[^}]*\}\}/, s);
  }
  window.wpMoney = money;

  /* ---------- toast ------------------------------------------------------ */
  var toast;
  function showToast(html) {
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'wp-toast';
      document.body.appendChild(toast);
    }
    toast.innerHTML = html;
    toast.classList.add('on');
    clearTimeout(showToast._t);
    showToast._t = setTimeout(function () { toast.classList.remove('on'); }, 4000);
  }

  /* ---------- cart ------------------------------------------------------- */
  function openThemeCart() {
    var own = document.querySelector('[data-wp-drawer]');
    if (own) { own.classList.add('on'); var sc = document.querySelector('[data-wp-scrim]'); if (sc) sc.classList.add('on');
      if (typeof window.wpCartFetch === 'function') window.wpCartFetch(); return true; }
    // Horizon exposes a cart drawer; try the documented hooks in order.
    var drawer = document.querySelector('cart-drawer-component, cart-drawer, #cart-drawer');
    if (drawer) {
      if (typeof drawer.open === 'function') { drawer.open(); return true; }
      if (typeof drawer.showDialog === 'function') { drawer.showDialog(); return true; }
      var dlg = drawer.querySelector('dialog');
      if (dlg && typeof dlg.showModal === 'function') { dlg.showModal(); return true; }
    }
    var opener = document.querySelector('[data-cart-drawer-opener], .header__cart-icon, a[href$="/cart"]');
    if (opener && opener.tagName !== 'A') { opener.click(); return true; }
    return false;
  }

  function refreshThemeCart() {
    if (typeof window.wpCartFetch === 'function') window.wpCartFetch();
    // Ask Horizon to re-render its cart bubble / drawer contents.
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    document.documentElement.dispatchEvent(new CustomEvent('cart:update', { bubbles: true }));
    if (window.Shopify && window.Shopify.onCartUpdate) { try { window.Shopify.onCartUpdate(); } catch (e) {} }
  }

  function addToCart(variantId, qty, btn) {
    if (!variantId) return;
    var label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'กำลังเพิ่ม…'; }
    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: qty || 1 }] })
    })
      .then(function (r) { return r.ok ? r.json() : r.json().then(function (e) { throw e; }); })
      .then(function () {
        if (btn) { btn.disabled = false; btn.textContent = 'เพิ่มแล้ว'; btn.classList.add('done'); }
        setTimeout(function () {
          if (btn) { btn.textContent = label; btn.classList.remove('done'); }
        }, 1400);
        refreshThemeCart();
        if (!openThemeCart()) {
          showToast('เพิ่มลงตะกร้าแล้ว <a href="/cart">ดูตะกร้า</a>');
        }
      })
      .catch(function (err) {
        if (btn) { btn.disabled = false; btn.textContent = label; }
        showToast((err && err.description) ? err.description : 'เพิ่มสินค้าไม่สำเร็จ กรุณาลองใหม่');
      });
  }

  function variantOf(btn) {
    // a card with a variant <select> always wins over the button's default id
    if (btn.hasAttribute('data-wp-add-var')) {
      var card = btn.closest('.wp-card');
      var sel = card && card.querySelector('[data-wp-var]');
      if (sel && sel.value) return sel.value;
    }
    return btn.getAttribute('data-wp-add');
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-wp-add]');
    if (!b) return;
    e.preventDefault();
    var lb = b.closest('.wp-lb');
    if (lb) closeLightbox();
    addToCart(variantOf(b), 1, b);
  });

  /* variant select keeps the price, the add button and the bundle pick in sync */
  document.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-wp-var]');
    if (!sel) return;
    var card = sel.closest('.wp-card');
    if (!card) return;
    var opt = sel.options[sel.selectedIndex];
    var price = Number(opt.getAttribute('data-price') || 0);
    var title = opt.getAttribute('data-title') || '';
    var priceEl = card.querySelector('[data-card-price]');
    if (priceEl && price) priceEl.textContent = money(price);
    var pick = card.querySelector('input[data-wp-pick]');
    if (pick) {
      pick.setAttribute('data-vid', sel.value);
      if (price) pick.setAttribute('data-price', price);
      if (title) pick.setAttribute('data-title', title);
      if (pick.checked) {
        pick.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  });

  /* ---------- PULSE cart drawer ----------------------------------------- */
  var wpHeader = $('[data-wp-header]');
  var wpDrawer = $('[data-wp-drawer]');
  var wpScrim = $('[data-wp-scrim]');

  function cartOpen() { if (wpDrawer) { wpDrawer.classList.add('on'); wpScrim.classList.add('on'); } }
  function cartClose() { if (wpDrawer) { wpDrawer.classList.remove('on'); wpScrim.classList.remove('on'); } }

  function renderCart(cart) {
    if (!wpDrawer) return;
    var box = $('[data-cart-items]', wpDrawer);
    var free = Number(wpHeader && wpHeader.getAttribute('data-free')) || 0;
    var note = (wpHeader && wpHeader.getAttribute('data-freenote')) || '';
    var bq = Number(wpHeader && wpHeader.getAttribute('data-bq')) || 0;
    var bp = Number(wpHeader && wpHeader.getAttribute('data-bp')) || 0;
    var t2 = Number(wpHeader && wpHeader.getAttribute('data-t2')) || 0;
    var t2a = (wpHeader && wpHeader.getAttribute('data-t2a')) || '';
    var t2c = (wpHeader && wpHeader.getAttribute('data-t2c')) || '';
    if (!cart.items.length) {
      box.innerHTML = '<p class="wp-cart-empty">ตะกร้ายังว่างอยู่</p>';
    } else {
      box.innerHTML = cart.items.map(function (it, i) {
        var img = it.image ? '<img src="' + it.image.replace(/(\.[a-z]+)(\?|$)/i, '_120x$1$2') + '" alt="">' : '';
        var variant = (it.variant_title && it.variant_title !== 'Default Title') ? it.variant_title : '';
        return '<div class="wp-ci">' +
          '<span class="wp-ci__m">' + img + '</span>' +
          '<div class="wp-ci__b"><b>' + it.product_title + '</b>' +
          (variant ? '<div class="wp-ci__v">' + variant + '</div>' : '') +
          '<div class="wp-ci__q">' +
            '<button type="button" data-cart-qty data-line="' + (i + 1) + '" data-to="' + (it.quantity - 1) + '" aria-label="ลด">−</button>' +
            '<span>' + it.quantity + '</span>' +
            '<button type="button" data-cart-qty data-line="' + (i + 1) + '" data-to="' + (it.quantity + 1) + '" aria-label="เพิ่ม">+</button>' +
          '</div></div>' +
          '<div class="wp-ci__p">' + money(it.final_line_price) +
          '<a class="wp-ci__x" href="#" data-cart-qty data-line="' + (i + 1) + '" data-to="0">ลบ</a></div></div>';
      }).join('');
    }
    $('[data-cart-total]', wpDrawer).textContent = money(cart.total_price);
    var bar = $('[data-ship-bar]', wpDrawer), sn = $('[data-ship-note]', wpDrawer);
    if (free > 0) {
      var goal = (cart.total_price >= free && t2 > 0) ? t2 : free;
      bar.style.width = Math.min(100, cart.total_price / goal * 100) + '%';
      var q = cart.item_count || 0;
      if (cart.total_price < free) { sn.textContent = 'ซื้อเพิ่มอีก ' + money(free - cart.total_price) + ' เพื่อรับส่งฟรี'; }
      else if (q < bq) { sn.textContent = 'ได้ส่งฟรีแล้ว · เพิ่มอีก ' + (bq - q) + ' ชิ้น รับส่วนลด ' + bp + '% ทั้งออเดอร์'; }
      else if (q < 5) { sn.textContent = 'ได้ส่วนลด ' + bp + '% แล้ว · เพิ่มอีก ' + (5 - q) + ' ชิ้น รับ 20% ทั้งออเดอร์'; } else { sn.textContent = 'ได้ส่งฟรี และส่วนลดจัดเซต 20% แล้ว · ลดให้อัตโนมัติตอนชำระเงิน'; }
    } else { bar.style.width = '100%'; sn.textContent = ''; }
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      el.classList.toggle('on', cart.item_count > 0);
    });
  }

  function cartFetch(open) {
    return fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart.js', {
      headers: { 'Accept': 'application/json' }
    }).then(function (r) { return r.json(); })
      .then(function (c) { renderCart(c); if (open) cartOpen(); return c; })
      .catch(function () {});
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-wp-cart-open]')) { e.preventDefault(); cartFetch(true); return; }
    if (e.target.closest('[data-wp-cart-close]') || e.target.closest('[data-wp-scrim]')) { cartClose(); return; }
    var q = e.target.closest('[data-cart-qty]');
    if (q) {
      e.preventDefault();
      fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: Number(q.getAttribute('data-line')), quantity: Number(q.getAttribute('data-to')) })
      }).then(function (r) { return r.json(); }).then(renderCart);
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') cartClose(); });
  if (wpDrawer) cartFetch(false);

  window.wpCartFetch = function () { cartFetch(false); }; document.addEventListener('click', function (e) { var a = e.target.closest ? e.target.closest('a[data-wp-set]') : null; if (!a) return; e.preventDefault(); var items = a.getAttribute('data-wp-set').split(',').map(function (s) { var p = s.split(':'); return { id: Number(p[0]), quantity: Number(p[1] || 1) }; }); var lb = a.textContent; a.textContent = 'กำลังเพิ่ม…'; fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) }).then(function (r) { if (!r.ok) throw 0; return r.json(); }).then(function () { a.textContent = lb; refreshThemeCart(); if (!openThemeCart()) showToast('เพิ่มเซตลงตะกร้าแล้ว'); }).catch(function () { window.location.href = a.getAttribute('href'); }); });

  /* ---------- nav: hover on desktop, tap on touch ------------------------ */
  if (window.matchMedia('(hover:none)').matches) {
    $$('.wp-nv').forEach(function (n) {
      var t = $('.wp-nv__t', n);
      if (!t) return;
      t.addEventListener('click', function (ev) {
        if (!n.classList.contains('open')) ev.preventDefault();
        var open = n.classList.contains('open');
        $$('.wp-nv').forEach(function (x) { x.classList.remove('open'); });
        if (!open) n.classList.add('open');
      });
    });
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.wp-nv')) $$('.wp-nv').forEach(function (x) { x.classList.remove('open'); });
    });
  }

    /* ---------- coupons v2: auto-apply + auto-upgrade ---------------------- */
  var CPK = 'wpCpOwned', CPL = 'wpCpList', cpBusy = false;
  function cpRoot(){ return (window.Shopify && window.Shopify.routes) ? window.Shopify.routes.root : '/'; }
  function cpRead(k){ try { return JSON.parse(localStorage.getItem(k) || '[]') || []; } catch (e) { return []; } }
  function cpSave(k, v){ try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  function cpM(n){ try { return money(n); } catch (e) { return 'THB ' + Math.round(n / 100); } }
  function cpSub(c){ return (c && typeof c.items_subtotal_price === 'number') ? c.items_subtotal_price : ((c && c.total_price) || 0); }

  (function cpHarvest(){
    var btns = document.querySelectorAll('.wp-cp__b[data-code]');
    if (!btns.length) return;
    var map = {};
    cpRead(CPL).forEach(function (c) { map[c.code] = c; });
    Array.prototype.forEach.call(btns, function (b) {
      var c = b.getAttribute('data-code');
      if (!c) return;
      map[c] = { code: c, min: (Number(b.getAttribute('data-min')) || 0) * 100, val: (Number(b.getAttribute('data-value')) || 0) * 100 };
    });
    cpSave(CPL, Object.keys(map).map(function (k) { return map[k]; }).filter(function (c) { return c.val > 0; }));
  })();

  function cpBest(sub){
    var owned = cpRead(CPK);
    var mine = cpRead(CPL).filter(function (c) { return owned.indexOf(c.code) >= 0; });
    if (!mine.length) return null;
    var ok = mine.filter(function (c) { return sub >= c.min; });
    var pick = ok.length
      ? ok.reduce(function (a, b) { return b.val > a.val ? b : a; })
      : mine.reduce(function (a, b) { return b.min < a.min ? b : a; });
    var next = ok.length ? (mine.filter(function (c) { return c.min > sub && c.val > pick.val; })
                   .sort(function (a, b) { return a.min - b.min; })[0] || null) : null;
    return { pick: pick, active: ok.length > 0, next: next };
  }

  function cpApply(code, cb){
    if (cpBusy) { if (cb) cb(null); return; }
    cpBusy = true;
    fetch(cpRoot() + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ discount: code })
    }).then(function (r) { return r.json(); })
      .then(function (c) { cpBusy = false; if (cb) cb(c); })
      .catch(function () { cpBusy = false; if (cb) cb(null); });
  }

  function cpBars(){
    var out = [];
    var sn = wpDrawer ? wpDrawer.querySelector('[data-ship-note]') : null;
    if (sn && sn.parentNode) {
      var a = sn.parentNode.querySelector('[data-cp-bar]');
      if (!a) { a = document.createElement('div'); a.className = 'wp-cpbar'; a.setAttribute('data-cp-bar', ''); sn.parentNode.insertBefore(a, sn.nextSibling); }
      out.push(a);
    }
    var sum = document.querySelector('.wp-cartsum');
    if (sum) {
      var p = sum.querySelector('[data-cp-bar]');
      if (!p) { p = document.createElement('div'); p.className = 'wp-cpbar wp-cpbar--page'; p.setAttribute('data-cp-bar', ''); sum.insertBefore(p, sum.firstChild); }
      out.push(p);
    }
    return out;
  }

  function cpTotal(c){
    if (!wpDrawer || !c) return;
    var t = wpDrawer.querySelector('[data-cart-total]');
    if (t) t.textContent = cpM(c.total_price);
  }

  function cpPaint(b, sub, cart){
    var dc = (cart && cart.discount_codes) || [];
    function live(code){ for (var i = 0; i < dc.length; i++) { if (dc[i].code === code && dc[i].applicable) return true; } return false; }
    var html = '';
    if (b) {
      var on = live(b.pick.code);
      var head = on ? ('ใช้คูปองลด ' + cpM(b.pick.val) + ' แล้ว') : ('เก็บคูปองลด ' + cpM(b.pick.val) + ' ไว้แล้ว');
      var tgt = b.next || (on ? null : b.pick);
      var line, pct;
      if (tgt && tgt.min > sub) {
        line = 'ซื้ออีก ' + cpM(tgt.min - sub) + ' รับลด ' + cpM(tgt.val) + (b.next ? ' แทน' : ' ทันที');
        pct = Math.max(4, Math.min(100, Math.round(sub / tgt.min * 100)));
      } else {
        line = 'ส่วนลดใส่ให้แล้ว ไม่ต้องกรอกโค้ดตอนชำระเงิน';
        pct = 100;
      }
      html = '<div class="wp-cpbar__t"><b>' + head + '</b><span>' + line + '</span></div><div class="wp-cpbar__tr"><i style="width:' + pct + '%"></i></div>';
    }
    cpBars().forEach(function (el) { el.innerHTML = html; el.hidden = !html; });
    var owned = cpRead(CPK);
    Array.prototype.forEach.call(document.querySelectorAll('.wp-cp__b[data-code]'), function (btn) {
      var c = btn.getAttribute('data-code'), has = owned.indexOf(c) >= 0, on2 = live(c);
      btn.classList.toggle('got', has);
      btn.classList.toggle('live', on2);
      btn.textContent = on2 ? 'กำลังใช้อยู่' : (has ? 'เก็บแล้ว' : c);
    });
  }

  function cpSync(cart){
    try {
      if (!cart) return;
      var sub = cpSub(cart), b = cpBest(sub);
      cpPaint(b, sub, cart);
      if (!b) return;
      var dc = (cart.discount_codes || []).map(function (d) { return d.code; });
      if (dc.length === 1 && dc[0] === b.pick.code) return;
      cpApply(b.pick.code, function (c2) {
        if (!c2) return;
        var s2 = cpSub(c2);
        cpPaint(cpBest(s2), s2, c2);
        cpTotal(c2);
      });
    } catch (e) {}
  }
  window.wpCpSync = cpSync;

  if (typeof renderCart === 'function') {
    var cpRC = renderCart;
    renderCart = function (c) { cpRC(c); cpSync(c); };
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('.wp-cp__b[data-code]');
    if (!b) return;
    var code = b.getAttribute('data-code');
    if (!code) return;
    var val = (Number(b.getAttribute('data-value')) || 0) * 100;
    var min = (Number(b.getAttribute('data-min')) || 0) * 100;
    var owned = cpRead(CPK);
    if (owned.indexOf(code) < 0) { owned.push(code); cpSave(CPK, owned); }
    b.textContent = 'กำลังใส่...';
    fetch(cpRoot() + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var bb = cpBest(cpSub(c));
        cpApply(bb ? bb.pick.code : code, function (c2) {
          c2 = c2 || c;
          var s2 = cpSub(c2);
          cpPaint(cpBest(s2), s2, c2);
          cpTotal(c2);
          var ok = false, dc = c2.discount_codes || [];
          for (var i = 0; i < dc.length; i++) { if (dc[i].code === code && dc[i].applicable) ok = true; }
          if (ok) showToast('ใส่ส่วนลด ' + cpM(val) + ' ให้แล้ว ไม่ต้องกรอกโค้ดตอนชำระเงิน');
          else if (min > s2) showToast('เก็บคูปองแล้ว · ซื้ออีก ' + cpM(min - s2) + ' ระบบจะลด ' + cpM(val) + ' ให้อัตโนมัติ');
          else showToast('เก็บคูปองแล้ว · ระบบจะเลือกใบที่คุ้มที่สุดให้อัตโนมัติ');
          if (document.querySelector('.wp-cartsum')) setTimeout(function () { location.reload(); }, 1000);
        });
      });
  });

  /* ---------- flash countdown + sold bars -------------------------------- */
  $$('[data-wp-clock]').forEach(function (el) {
    var endAttr = el.getAttribute('data-wp-clock');       // "HH:MM" local reset time
    function tick() {
      var now = new Date();
      var parts = (endAttr || '20:00').split(':');
      var end = new Date(now);
      end.setHours(Number(parts[0]) || 20, Number(parts[1]) || 0, 0, 0);
      if (end <= now) end.setDate(end.getDate() + 1);
      var d = Math.max(0, Math.floor((end - now) / 1000));
      var pad = function (n) { return String(n).padStart(2, '0'); };
      var hh = $('[data-hh]', el), mm = $('[data-mm]', el), ss = $('[data-ss]', el);
      if (hh) hh.textContent = pad(Math.floor(d / 3600));
      if (mm) mm.textContent = pad(Math.floor((d % 3600) / 60));
      if (ss) ss.textContent = pad(d % 60);
    }
    tick();
    setInterval(tick, 1000);
  });

  var barIO = new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (!e.isIntersecting) return;
      $$('[data-w]', e.target).forEach(function (b, i) {
        setTimeout(function () { b.style.width = b.getAttribute('data-w') + '%'; }, i * 110);
      });
      barIO.unobserve(e.target);
    });
  }, { threshold: 0.25 });
  $$('[data-wp-bars]').forEach(function (el) { barIO.observe(el); });

  /* ---------- generic tab panels (bestsellers, goals, videos, reviews) --- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-wp-tab]');
    if (!b) return;
    var scope = b.closest('[data-wp-tabs]');
    if (!scope) return;
    var key = b.getAttribute('data-wp-tab');
    $$('[data-wp-tab]', scope).forEach(function (x) { x.classList.toggle('on', x === b); });
    $$('[data-wp-pane]', scope).forEach(function (p) {
      p.classList.toggle('on', p.getAttribute('data-wp-pane') === key);
    });
  });

  /* ---------- goal finder ------------------------------------------------ */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-wp-goal]');
    if (!b) return;
    var scope = b.closest('[data-wp-goals]');
    if (!scope) return;
    var key = b.getAttribute('data-wp-goal');
    var wasOn = b.classList.contains('on');
    $$('[data-wp-goal]', scope).forEach(function (x) { x.classList.remove('on'); });
    $$('[data-wp-goalpane]', scope).forEach(function (p) { p.classList.remove('on'); });
    if (wasOn) return;
    b.classList.add('on');
    var pane = scope.querySelector('[data-wp-goalpane="' + key + '"]');
    if (pane) {
      pane.classList.add('on');
      pane.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
  });

  /* ---------- advisor: free text -> goal ---------------------------------
     Deliberately conservative. Anything that reads like a medical question is
     handed to a human instead of being answered with a product. Supplements
     are not medicine and this tool never pretends otherwise. */
  $$('[data-wp-advisor]').forEach(function (adv) {
    var scope = adv.closest('[data-wp-goals]');
    if (!scope) return;
    var input = $('[data-adv-input]', adv);
    var msg = $('[data-adv-msg]', adv);
    var careTpl = $('[data-adv-care]', adv);
    var noTpl = $('[data-adv-nomatch]', adv);
    var blocked = (adv.getAttribute('data-block-words') || '')
      .split(',').map(function (x) { return x.trim(); })
      .filter(function (x) { return x.length >= 3; });

    function say(html, care) {
      msg.innerHTML = html;
      msg.classList.add('on');
      msg.classList.toggle('wp-adv__msg--care', !!care);
    }
    function clearGoals() {
      $$('[data-wp-goal]', scope).forEach(function (x) { x.classList.remove('on'); });
      $$('[data-wp-goalpane]', scope).forEach(function (p) { p.classList.remove('on'); });
    }

    function run() {
      var q = (input.value || '').trim();
      if (!q) { msg.classList.remove('on'); return; }
      var low = q.toLowerCase();

      // 1. medical language -> hand off to a person, show nothing else
      for (var i = 0; i < blocked.length; i++) {
        if (blocked[i] && low.indexOf(blocked[i].toLowerCase()) !== -1) {
          clearGoals();
          say(careTpl ? careTpl.innerHTML : '', true);
          msg.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          return;
        }
      }

      // 2. score each goal by how many of its keywords appear
      var best = null, bestScore = 0;
      $$('[data-wp-goal]', scope).forEach(function (btn) {
        var kws = (btn.getAttribute('data-keywords') || '')
          .split(',').map(function (x) { return x.trim().toLowerCase(); }).filter(Boolean);
        var score = 0;
        kws.forEach(function (k) { if (low.indexOf(k) !== -1) score += k.length; });
        var title = (btn.getAttribute('data-goal-title') || '').toLowerCase();
        if (title && low.indexOf(title) !== -1) score += title.length * 2;
        if (score > bestScore) { bestScore = score; best = btn; }
      });

      if (!best) {
        clearGoals();
        say(noTpl ? noTpl.innerHTML : '', false);
        return;
      }
      msg.classList.remove('on');
      clearGoals();
      best.classList.add('on');
      var pane = scope.querySelector('[data-wp-goalpane="' + best.getAttribute('data-wp-goal') + '"]');
      if (pane) {
        pane.classList.add('on');
        pane.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    }

    var go = $('[data-adv-go]', adv);
    if (go) go.addEventListener('click', run);
    if (input) input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); run(); }
    });
    $$('[data-adv-ex]', adv).forEach(function (b) {
      b.addEventListener('click', function () { input.value = b.textContent.trim(); run(); });
    });
  });

  /* ---------- bundle builder inside each goal pane ---------------------- */
  $$('[data-wp-bundle]').forEach(function (bar) {
    var pane = bar.closest('[data-wp-goalpane]') || bar.parentElement;
    var min = Number(bar.getAttribute('data-min')) || 3;
    var pct = Number(bar.getAttribute('data-pct')) || 0;
    var code = (bar.getAttribute('data-code') || '').trim();
    var hint = $('[data-bundle-hint]', bar);
    var list = $('[data-bundle-list]', bar);
    var total = $('[data-bundle-total]', bar);
    var btn = $('[data-bundle-add]', bar);
    var hintText = hint ? hint.textContent : '';

    function picks() { return $$('input[data-wp-pick]:checked', pane); }

    function refresh() {
      var sel = picks();
      var sub = sel.reduce(function (s, i) { return s + Number(i.getAttribute('data-price') || 0); }, 0);
      var ok = sel.length >= min;
      var min2 = 5, pct2 = 20; var rate = sel.length >= min2 ? pct2 : pct; var off = ok ? Math.round(sub * rate / 100) : 0;
      list.textContent = sel.length
        ? sel.map(function (i) { return i.getAttribute('data-title'); }).join(' · ')
        : '';
      if (hint) hint.textContent = ok
        ? (sel.length >= min2 ? 'ครบแล้ว รับส่วนลด ' + pct2 + '% ทันที' : 'ได้ส่วนลด ' + pct + '% แล้ว · เลือกอีก ' + (min2 - sel.length) + ' ชิ้น รับ ' + pct2 + '%')
        : 'เลือกอีก ' + (min - sel.length) + ' ชิ้น รับส่วนลด ' + pct + '%';
      total.innerHTML = sel.length
        ? (ok && off ? money(sub - off) + '<s>' + money(sub) + '</s>' : money(sub))
        : '—';
      btn.disabled = !ok;
    }

    pane.addEventListener('change', function (e) {
      if (e.target.matches('input[data-wp-pick]') || e.target.matches('[data-wp-var]')) refresh();
    });

    btn.addEventListener('click', function () {
      var sel = picks();
      if (sel.length < min) return;
      var items = sel.map(function (i) { return { id: Number(i.getAttribute('data-vid')), quantity: 1 }; });
      var label = btn.textContent;
      btn.disabled = true; btn.textContent = 'กำลังเพิ่ม…';
      fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { return r.ok ? r.json() : r.json().then(function (e) { throw e; }); })
        .then(function () {
          sel.forEach(function (i) { i.checked = false; });
          refresh();
          btn.textContent = label;
          if (code) {
            window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/cart';
          } else {
            refreshThemeCart();
            if (!openThemeCart()) showToast('เพิ่มเซตลงตะกร้าแล้ว <a href="/cart">ดูตะกร้า</a>');
          }
        })
        .catch(function (err) {
          btn.disabled = false; btn.textContent = label;
          showToast((err && err.description) ? err.description : 'เพิ่มเซตไม่สำเร็จ กรุณาลองใหม่');
        });
    });

    refresh();
  });

  /* ---------- platform review filter ------------------------------------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-wp-pf]');
    if (!b) return;
    var scope = b.closest('[data-wp-reviews]');
    if (!scope) return;
    var key = b.getAttribute('data-wp-pf');
    $$('[data-wp-pf]', scope).forEach(function (x) { x.classList.toggle('on', x === b); });
    $$('.wp-rev', scope).forEach(function (r) {
      r.classList.toggle('hide', key !== 'all' && r.getAttribute('data-pf') !== key);
    });
  });

  /* ---------- video lightbox --------------------------------------------- */
  var lb = null;
  function ensureLightbox() {
    if (lb) return lb;
    lb = document.createElement('div');
    lb.className = 'wp-lb wp';
    lb.innerHTML =
      '<div class="wp-lb__w">' +
      '<div class="wp-lb__v" data-lbv>' +
      '<button class="wp-lb__x" data-lbx aria-label="ปิด"><svg viewBox="0 0 24 24"><path d="M6 6l12 12M18 6L6 18"/></svg></button>' +
      '<span class="wp-play"></span><div class="wp-lb__cap" data-lbcap></div></div>' +
      '<div class="wp-lb__p"><h4 data-lbt></h4><span data-lbm></span>' +
      '<div class="wp-lbprod" data-lbprod></div>' +
      '<div data-lbcta></div></div></div>';
    document.body.appendChild(lb);
    lb.addEventListener('click', function (e) { if (e.target === lb || e.target.closest('[data-lbx]')) closeLightbox(); });
    return lb;
  }
  function closeLightbox() {
    if (!lb) return;
    lb.classList.remove('on');
    document.body.style.overflow = '';
    var v = lb.querySelector('video, iframe');
    if (v) v.remove();
  }
  window.wpCloseLightbox = closeLightbox;
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeLightbox(); });

  document.addEventListener('click', function (e) {
    var card = e.target.closest('[data-wp-video]');
    if (!card) return;
    e.preventDefault();
    var el = ensureLightbox();
    var v = el.querySelector('[data-lbv]');
    var old = v.querySelector('video, iframe');
    if (old) old.remove();
    var src = card.getAttribute('data-video-src');
    var embed = card.getAttribute('data-video-embed');
    if (src) {
      var vid = document.createElement('video');
      vid.src = src; vid.controls = true; vid.autoplay = true; vid.playsInline = true;
      v.insertBefore(vid, v.firstChild);
    } else if (embed) {
      var f = document.createElement('iframe');
      f.src = embed; f.allow = 'autoplay; encrypted-media; picture-in-picture'; f.allowFullscreen = true;
      v.insertBefore(f, v.firstChild);
    }
    var poster = card.getAttribute('data-poster');
    v.style.backgroundImage = poster ? 'url(' + poster + ')' : '';
    v.style.backgroundSize = 'cover';
    v.style.backgroundPosition = 'center';
    el.querySelector('[data-lbcap]').textContent = card.getAttribute('data-title') || '';
    el.querySelector('[data-lbt]').textContent = card.getAttribute('data-title') || '';
    el.querySelector('[data-lbm]').textContent = card.getAttribute('data-meta') || '';
    el.querySelector('[data-lbprod]').innerHTML = card.getAttribute('data-prod') || '';
    el.querySelector('[data-lbcta]').innerHTML = card.getAttribute('data-cta') || '';
    el.classList.add('on');
    document.body.style.overflow = 'hidden';
  });

  /* ---------- FAQ accordion ---------------------------------------------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('.wp-q > button');
    if (!b) return;
    var q = b.parentElement, a = q.querySelector('.wp-q__a'), open = q.classList.contains('on');
    var scope = q.closest('.wp-faq');
    $$('.wp-q', scope).forEach(function (x) {
      x.classList.remove('on');
      x.querySelector('.wp-q__a').style.maxHeight = null;
    });
    if (!open) { q.classList.add('on'); a.style.maxHeight = a.scrollHeight + 'px'; }
  });

  /* ---------- health tools ----------------------------------------------- */
  var toolRoot = $('[data-wp-tools]');
  if (toolRoot) {
    var SCOOP = Number(toolRoot.getAttribute('data-scoop')) || 29;
    var SCOOP_LABEL = toolRoot.getAttribute('data-scoop-label') || 'สินค้าหลักของเรา';
    var SCOOP_SERV = toolRoot.getAttribute('data-scoop-servings') || '';
    var SCOOP_VID = toolRoot.getAttribute('data-scoop-variant') || '';
    var SCOOP_PRICE = toolRoot.getAttribute('data-scoop-price') || '';
    var SCOOP_URL = toolRoot.getAttribute('data-scoop-url') || '';
    var SCOOP_MULTI = toolRoot.getAttribute('data-scoop-multi') === '1';
    var T = { w: 65, act: 'light', tab: 'protein', ex: 0, g: SCOOP };
    var ACT = [
      ['sed', 'นั่งทำงาน ไม่ค่อยขยับ', 0.8, 1.0],
      ['light', 'ออกกำลังกาย 1–3 วัน/สัปดาห์', 1.0, 1.3],
      ['mod', 'ออกกำลังกาย 4–6 วัน/สัปดาห์', 1.4, 1.7],
      ['high', 'เล่นกีฬาหนัก / เวทเทรนนิ่งจริงจัง', 1.6, 2.0]
    ];
    var inElReal = $('[data-tool-in]', toolRoot), outEl = $('[data-tool-out]', toolRoot);
    var inElDummy = document.createElement('div');
    var inEl = inElReal;
    function renderOut() { inEl = inElDummy; try { render(); } finally { inEl = inElReal; } }

    function ctaHTML() {
      var price = SCOOP_PRICE ? ' · ' + SCOOP_PRICE : '';
      if (SCOOP_VID && !SCOOP_MULTI) {
        return '<button class="wp-btn wp-btn--p wp-tool__cta" type="button" data-wp-add="' + SCOOP_VID +
               '">หยิบใส่ตะกร้า' + price + '</button>' +
               (SCOOP_URL ? '<a class="wp-tool__link" href="' + SCOOP_URL + '">ดูรายละเอียดสินค้า</a>' : '');
      }
      if (SCOOP_URL) {
        return '<a class="wp-btn wp-btn--p wp-tool__cta" href="' + SCOOP_URL +
               '">ดูสินค้าและเลือกรสชาติ' + price + '</a>' +
               '<span class="wp-tool__note">มีให้เลือกหลายรสชาติ เลือกได้ในหน้าสินค้า</span>';
      }
      return '';
    }
    function keepCaret(id) {
      var el = document.getElementById(id);
      if (!el) return;
      el.focus();
      try { el.setSelectionRange(el.value.length, el.value.length); } catch (e) {}
    }
    function render() {
      if (T.tab === 'compare') {
        inEl.innerHTML =
          '<div class="wp-fld"><label>อยากได้โปรตีนกี่กรัม</label>' +
          '<input id="wpTG" type="number" min="5" max="80" value="' + T.g + '"></div>' +
          '<p style="font-size:13.5px;color:var(--wp-mut);line-height:1.8">ใส่ปริมาณโปรตีนที่ต้องการ ' +
          'แล้วดูว่าต้องกินอาหารแต่ละอย่างเท่าไหร่ถึงจะได้เท่ากัน ค่าอ้างอิงจากตารางคุณค่าทางโภชนาการมาตรฐาน ' +
          'อาจต่างกันตามแหล่งวัตถุดิบ</p>' +
          '<div class="wp-note">ค่านี้ใช้เปรียบเทียบปริมาณโปรตีนเท่านั้น ไม่ได้เทียบสารอาหารอื่น ไขมัน หรือพลังงานที่ได้รับ</div>';
        var g = T.g || SCOOP;
        var F = [['ไข่ไก่ฟองใหญ่', 6.3, 'ฟอง', 0], ['อกไก่สุก', 31, 'กรัม', 100],
                 ['เต้าหู้แข็ง', 14.5, 'กรัม', 100], ['นมจืด', 3.3, 'มล.', 100],
                 ['ถั่วลันเตาต้ม', 5.4, 'กรัม', 100], ['ปลาทูน่าในน้ำ', 24, 'กรัม', 100]];
        outEl.innerHTML =
          '<div style="font-size:13px;color:var(--wp-head);opacity:.8">โปรตีน ' + g + ' กรัม เทียบเท่ากับ</div>' +
          '<div class="wp-cmp" style="margin-top:14px">' +
          F.map(function (f) {
            var per = f[3] || 1, amt = g / f[1] * per;
            var v = f[3] ? Math.round(amt) : Math.round(amt * 10) / 10;
            return '<div><b>' + v.toLocaleString('en-US') + '</b><span>' + f[2] + ' · ' + f[0] + '</span></div>';
          }).join('') + '</div>' +
          '<div class="wp-cover" style="margin-top:14px">' +
          '<div style="display:flex;justify-content:space-between;align-items:baseline">' +
          '<span style="font-size:13px">' + SCOOP_LABEL + '</span>' +
          '<b style="font-family:var(--wp-data);color:var(--wp-head)">' + (g / SCOOP).toFixed(1) + ' หน่วยบริโภค</b></div>' +
          '<div style="font-size:11.5px;color:var(--wp-mut);margin-top:6px">1 หน่วยบริโภคให้โปรตีน ' +
          SCOOP + ' กรัม' + (SCOOP_SERV ? ' · ' + SCOOP_SERV : '') + '</div>' + ctaHTML() + '</div>';
        var tg = document.getElementById('wpTG');
        if (tg) tg.oninput = function (e) { T.g = Number(e.target.value) || T.g; renderOut(); };
        return;
      }
      if (T.tab === 'water') {
        inEl.innerHTML =
          '<div class="wp-fld"><label>น้ำหนักตัว (กิโลกรัม)</label>' +
          '<input id="wpTW" type="number" min="30" max="200" value="' + T.w + '"></div>' +
          '<div class="wp-fld"><label>วันนี้ออกกำลังกายไหม</label><div class="wp-sel"><select id="wpTEx">' +
          '<option value="0"' + (T.ex === 0 ? ' selected' : '') + '>ไม่ได้ออกกำลังกายวันนี้</option>' +
          '<option value="1"' + (T.ex === 1 ? ' selected' : '') + '>ออกกำลังกายราว 1 ชั่วโมง</option>' +
          '<option value="2"' + (T.ex === 2 ? ' selected' : '') + '>ออกกำลังกายหนักเกิน 1 ชั่วโมง</option>' +
          '</select></div></div>' +
          '<div class="wp-note">ค่าประมาณสำหรับผู้ใหญ่สุขภาพดีในภูมิอากาศทั่วไป ผู้ที่มีโรคไต โรคหัวใจ ' +
          'หรืออยู่ระหว่างการรักษา ควรปรึกษาแพทย์ก่อนปรับปริมาณน้ำ</div>';
        var lo = Math.round((T.w * 30 + T.ex * 500) / 10) * 10;
        var hi = Math.round((T.w * 35 + T.ex * 700) / 10) * 10;
        outEl.innerHTML =
          '<div style="font-size:13px;color:var(--wp-head);opacity:.8">ควรดื่มน้ำประมาณ</div>' +
          '<div class="wp-big">' + (lo / 1000).toFixed(1) + '–' + (hi / 1000).toFixed(1) + '<small>ลิตร/วัน</small></div>' +
          '<div style="margin-top:18px">' +
          '<div class="wp-outrow"><span>เทียบเป็นแก้ว (250 มล.)</span><b>' + Math.round(lo / 250) + '–' + Math.round(hi / 250) + ' แก้ว</b></div>' +
          '<div class="wp-outrow"><span>ช่วงตื่นนอน–เที่ยง</span><b>' + Math.round(lo * .4 / 100) * 100 + '–' + Math.round(hi * .4 / 100) * 100 + ' มล.</b></div>' +
          '<div class="wp-outrow" style="border:none"><span>ช่วงบ่าย–ก่อนนอน</span><b>' + Math.round(lo * .6 / 100) * 100 + '–' + Math.round(hi * .6 / 100) * 100 + ' มล.</b></div></div>';
        var tw = document.getElementById('wpTW');
        if (tw) tw.oninput = function (e) { T.w = Number(e.target.value) || T.w; renderOut(); };
        var ex = document.getElementById('wpTEx');
        if (ex) ex.onchange = function (e) { T.ex = Number(e.target.value); renderOut(); };
        return;
      }
      inEl.innerHTML =
        '<div class="wp-fld"><label>น้ำหนักตัว (กิโลกรัม)</label>' +
        '<input id="wpTW" type="number" min="30" max="200" value="' + T.w + '"></div>' +
        '<div class="wp-fld"><label>ระดับกิจกรรมของคุณ</label><div class="wp-sel"><select id="wpTAct">' +
        ACT.map(function (a) {
          return '<option value="' + a[0] + '"' + (a[0] === T.act ? ' selected' : '') + '>' + a[1] + '</option>';
        }).join('') + '</select></div></div>' +
        '<div class="wp-note">ค่าที่ได้เป็นค่าประมาณสำหรับผู้ใหญ่สุขภาพดี อ้างอิงช่วง 0.8–2.0 กรัมต่อน้ำหนักตัว ' +
        '1 กิโลกรัม ผู้ที่มีโรคประจำตัวโดยเฉพาะโรคไต ผู้ตั้งครรภ์ หรือให้นมบุตร ' +
        'ควรปรึกษาแพทย์หรือนักกำหนดอาหารก่อนปรับปริมาณโปรตีน</div>';
      var a = ACT.filter(function (x) { return x[0] === T.act; })[0];
      var plo = Math.round(T.w * a[2]), phi = Math.round(T.w * a[3]), mid = Math.round((plo + phi) / 2);
      var pct = Math.min(100, Math.round(SCOOP / mid * 100));
      outEl.innerHTML =
        '<div style="font-size:13px;color:var(--wp-head);opacity:.8">โปรตีนที่ควรได้ต่อวัน</div>' +
        '<div class="wp-big">' + plo + '–' + phi + '<small>กรัม/วัน</small></div>' +
        '<div style="margin-top:18px">' +
        '<div class="wp-outrow"><span>กระจาย 3 มื้อ · มื้อละ</span><b>' + Math.round(plo / 3) + '–' + Math.round(phi / 3) + ' ก.</b></div>' +
        '<div class="wp-outrow"><span>ถ้าแบ่ง 4 มื้อ · มื้อละ</span><b>' + Math.round(plo / 4) + '–' + Math.round(phi / 4) + ' ก.</b></div>' +
        '<div class="wp-outrow" style="border:none"><span>เทียบไข่ไก่ทั้งวัน</span><b>' + Math.round(plo / 6.3) + '–' + Math.round(phi / 6.3) + ' ฟอง</b></div></div>' +
        '<div class="wp-cover"><div style="display:flex;justify-content:space-between;align-items:baseline">' +
        '<span style="font-size:13px">1 หน่วยบริโภค ' + SCOOP_LABEL + '</span>' +
        '<b style="font-family:var(--wp-data);color:var(--wp-head)">' + pct + '%</b></div>' +
        '<div class="wp-cover__b"><i id="wpCov"></i></div>' +
        '<div style="font-size:11.5px;color:var(--wp-mut)">ให้โปรตีน ' + SCOOP + ' กรัม คิดเป็น ' + pct +
        '% ของเป้าหมายกลาง ' + mid + ' กรัม/วัน</div>' + ctaHTML() + '</div>';
      setTimeout(function () { var c = document.getElementById('wpCov'); if (c) c.style.width = pct + '%'; }, 60);
      var tw2 = document.getElementById('wpTW');
      if (tw2) tw2.oninput = function (e) { T.w = Number(e.target.value) || T.w; renderOut(); };
      var act = document.getElementById('wpTAct');
      if (act) act.onchange = function (e) { T.act = e.target.value; renderOut(); };
    }
    var tabs = $('[data-tool-tabs]', toolRoot);
    if (tabs) tabs.addEventListener('click', function (e) {
      var b = e.target.closest('button'); if (!b) return;
      $$('button', tabs).forEach(function (x) { x.classList.toggle('on', x === b); });
      T.tab = b.getAttribute('data-k'); render();
    });
    render();
  }

  /* ---------- rewards ----------------------------------------------------- */
  var rwRoot = $('[data-wp-rewards]');
  if (rwRoot) {
    var startPts = Number(rwRoot.getAttribute('data-points'));
    if (!isFinite(startPts)) startPts = 0;
    var PT = startPts;
    var tiers = [];
    $$('[data-tier]', rwRoot).forEach(function (t) {
      tiers.push([t.getAttribute('data-tier'), Number(t.getAttribute('data-min')) || 0, t]);
    });
    tiers.sort(function (a, b) { return a[1] - b[1]; });

    function drawRW() {
      $$('[data-pt-val]').forEach(function (el) { el.innerHTML = fmtInt(PT) + '<small>แต้ม</small>'; });
      $$('[data-pt-chip]').forEach(function (el) { el.textContent = fmtInt(PT); });
      var next = null, lo = tiers[0];
      tiers.forEach(function (t) { if (t[1] <= PT) lo = t; });
      for (var i = 0; i < tiers.length; i++) { if (tiers[i][1] > PT) { next = tiers[i]; break; } }
      var bar = $('[data-pt-bar]', rwRoot);
      if (bar) bar.style.width = (next ? Math.round((PT - lo[1]) / (next[1] - lo[1]) * 100) : 100) + '%';
      var nx = $('[data-pt-next]', rwRoot);
      if (nx) nx.textContent = next
        ? 'อีก ' + fmtInt(next[1] - PT) + ' แต้ม เลื่อนเป็นสมาชิกระดับ' + next[0]
        : 'คุณอยู่ระดับสูงสุดแล้ว';
      tiers.forEach(function (t) { t[2].classList.toggle('on', t === lo); });
      $$('[data-rw-cost]', rwRoot).forEach(function (btn) {
        var cost = Number(btn.getAttribute('data-rw-cost'));
        if (btn.classList.contains('done')) return;
        if (PT >= cost) { btn.disabled = false; btn.textContent = btn.getAttribute('data-label') || 'แลกเลย'; }
        else { btn.disabled = true; btn.textContent = 'ต้องการอีก ' + fmtInt(cost - PT) + ' แต้ม'; }
      });
    }
    rwRoot.addEventListener('click', function (e) {
      var b = e.target.closest('[data-rw-cost]');
      if (!b || b.disabled) return;
      var cost = Number(b.getAttribute('data-rw-cost'));
      if (PT < cost) return;
      PT -= cost;
      b.classList.add('done');
      b.textContent = 'แลกแล้ว';
      showToast('แลกของรางวัลแล้ว ทีมงานจะยืนยันสิทธิ์ทาง LINE ภายใน 24 ชั่วโมง');
      setTimeout(function () { b.classList.remove('done'); drawRW(); }, 1200);
    });
    drawRW();
  }
})();

/* ---------- product gallery: thumbnail swaps the main image --------------- */
(function () {
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-wp-thumb]');
    if (!t) return;
    var main = document.getElementById('wpPdpMain');
    if (!main) return;
    main.src = t.getAttribute('data-wp-thumb');
    Array.prototype.forEach.call(document.querySelectorAll('[data-wp-thumb]'), function (x) {
      x.classList.toggle('on', x === t);
    });
  });
})();
